import React from "react";
import { ConfigProvider } from "antd";

export const theme = {
  components: {
    // 🔹 Input (includes Input.TextArea and Input.Search base)
    Input: {
      colorBgContainer: "#FC442033",
      colorBorder: "#424242",
      colorTextPlaceholder: "#999",
      activeBorderColor: "#FC4420",
      hoverBorderColor: "#FC4420",
      colorText: "#fff",
      borderRadius: 8,
      controlHeight: 40,
      // For search icon inside Input.Search
      addonBg: "#141414",
      colorIcon: "#ffffff",
      colorIconHover: "#FC4420",
    },

    // 🔸 Select (includes dropdown styles)
    Select: {
      colorBgContainer: "", // input box background
      colorBorder: "#424242", // border color
      colorTextPlaceholder: "#999", // placeholder text
      colorText: "#fff", // text color inside select
      optionSelectedBg: "#2a2a2a", // selected option background
      optionSelectedColor: "#FC4420", // selected option text color
      optionActiveBg: "#1f1f1f", // hovered option background
      optionFontSize: 14,
      optionPadding: "6px 12px",
      colorBgElevated: "#1a1a1a", // dropdown background
      activeBorderColor: "#FC4420",
      hoverBorderColor: "#FC4420",
      borderRadius: 8,
      controlHeight: 40,

      // 🔹 Add these two:
      colorIcon: "#999", // normal icon color
      colorIconHover: "#FC4420", // hover icon color
    },

    // 🔹 Segmented
    Segmented: {
      colorBgContainer: "#1f1f1f",
      colorBgLayout: "#141414",
      colorText: "#fff",
      colorTextLabel: "#fff",
      colorTextHover: "#FC4420",
      colorPrimary: "#FC4420",
      itemSelectedBg: "#2a2a2a",
      itemSelectedColor: "#FC4420",
      borderRadius: 8,
      borderColor: "#424242",
    },

    Button: {
      colorBgContainer: "#FC4420",
      colorText: "#fff",
      colorBorder: "#FC4420",
      colorBgHover: "#FC4420",
      borderRadius: 8,
    },
  },
};
